import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateAffiliation } from '~/services/AgentHub/AgentService';

import { UpdateAffiliationParams } from '~/types/services/agentHub';

import { affiliationQueryKeys } from './useGetAffiliation';
import { affiliationsQueryKeys } from './useListAffiliations';

interface UpdateAffiliationVariables {
  affiliationId: string;
  data: UpdateAffiliationParams;
}

interface UseUpdateAffiliationOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useUpdateAffiliation(options: UseUpdateAffiliationOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ affiliationId, data }: UpdateAffiliationVariables) => {
      return await updateAffiliation(affiliationId, data);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: affiliationsQueryKeys.all });
      queryClient.invalidateQueries({ queryKey: affiliationQueryKeys.detail(variables.affiliationId) });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
